interface Action {
    payload: any,
    type: string
}

export const GET_COURTS = 'GET_COURTS',
             RESET_COURTS = 'RESET_COURTS',
             GET_COURTS_ERROR = 'GET_COURTS_ERROR';

const CourtsReducer = (state = [], action: Action) => {
    switch (action.type) {
        case GET_COURTS:
            return action.payload;
        case RESET_COURTS:
            return [];
        default:
            return state;
    }
};

export default CourtsReducer;
